module.exports = __webpack_public_path__ + "static/media/DentAndBuckle.1d266450.svg";